import { UNKNOWN } from 'pages/item/v2/components/ProtectedData';

export const COLORS = {
    BACKGROUND: {
        High: '#FFEFEF',
        Medium: '#FFF3E4',
        Low: '#EAF9F7',
        [UNKNOWN]: '#F3F3F3'
    },
    ACCENT: {
        High: '#FF3306',
        Medium: '#FFC006',
        Low: '#82C4BB',
        [UNKNOWN]: '#E6E6E6'
    }
} as const;

export const NAMES_MAP = {
    attackVector: 'Attack Vector',
    attackComplexity: 'Attack Complexity',
    privilegesRequired: 'Privileges Required',
    userInteraction: 'User Interaction',
    accessVector: 'Access Vector',
    accessComplexity: 'Access Complexity',
    authentication: 'Authentication',
    confidentialityImpact: 'Confidentiality Impact',
    integrityImpact: 'Integrity Impact',
    availabilityImpact: 'Availability Impact',
    scope: 'Scope',
    percentile: 'Percentile',
    confidence: 'Confidence',
    ['Automatable']: 'Automatable',
    ['Exploitation']: 'Exploitation',
    ['Technical Impact']: 'Technical Impact'
} as const;
